import Nullstack from 'nullstack';
export default function IconTexture({
  size = 24,
  color = "currentColor",
  stroke = 2
}) {
  const allProps = {
    width: size,
    height: size,
    "stroke-width": stroke,
    stroke: color
  };
  return Nullstack.element("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "inline-flex icon icon-tabler icon-tabler-texture",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    fill: "none",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    ...allProps
  }, "   ", Nullstack.element("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), "   ", Nullstack.element("path", {
    d: "M6 3l-3 3"
  }), "   ", Nullstack.element("path", {
    d: "M21 18l-3 3"
  }), "   ", Nullstack.element("path", {
    d: "M11 3l-8 8"
  }), "   ", Nullstack.element("path", {
    d: "M16 3l-13 13"
  }), "   ", Nullstack.element("path", {
    d: "M21 3l-18 18"
  }), "   ", Nullstack.element("path", {
    d: "M21 8l-13 13"
  }), "   ", Nullstack.element("path", {
    d: "M21 13l-8 8"
  }), " ");
}